import { __exports as encoder } from "./index219.js";
import { __require as requireConstants } from "./index190.js";
var hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder;
  hasRequiredEncoder = 1;
  Object.defineProperty(encoder, "__esModule", {
    value: true
  });
  var _constants = requireConstants();
  var encode = function encode2(data, structure, separator) {
    var encoded = data.split("").map(function(val, idx) {
      return _constants.BINARIES[structure[idx]];
    }).map(function(val, idx) {
      return val ? val[data[idx]] : "";
    });
    if (separator) {
      var last = data.length - 1;
      encoded = encoded.map(function(val, idx) {
        return idx < last ? val + separator : val;
      });
    }
    return encoded.join("");
  };
  encoder.default = encode;
  return encoder;
}
export {
  requireEncoder as __require
};
//# sourceMappingURL=index194.js.map
